import React, { useLayoutEffect, useState } from 'react';
import './style.scss';
import LoginFirstStage from './stages/first';
import LoginSecondStage from './stages/second';
import clsx from 'clsx';
import LoginThirdStage from './stages/third';

enum Stages {
  FIRST,
  SECOND,
  THIRD
}

interface Props {
  onLogin: () => any;
}

const Login = ({ onLogin }: Props) => {
  const [stage, setStage] = useState(Stages.FIRST);
  const [switching, setSwitching] = useState(false);

  useLayoutEffect(() => {
    document.body.className = 'unscrollable';
  }, []);

  const handleLogin = () => {
    document.body.className = '';
    onLogin();
  };

  const switchToStage = (stage: Stages) => {
    setSwitching(true);
    setTimeout(() => {
      setStage(stage);
    }, 250);
    setTimeout(() => {
      setSwitching(false);
    }, 500);
  };

  return (
    <div className={clsx('login-screen', switching && 'switch')}>
      <Content
        stage={stage}
        goSecond={() => switchToStage(Stages.SECOND)}
        goThird={() => switchToStage(Stages.THIRD)}
        login={() => handleLogin()}
      />
    </div>
  );
};

interface ContentProps {
  stage: Stages;
  goSecond: () => any;
  goThird: () => any;
  login: () => any;
}

const Content = ({ stage, goSecond, goThird, login }: ContentProps) => {
  switch (stage) {
    case Stages.FIRST:
      return <LoginFirstStage onComplete={goSecond} />;
    case Stages.SECOND:
      return <LoginSecondStage onComplete={goThird} />;
    case Stages.THIRD:
      return <LoginThirdStage onComplete={login} />;
  }
};

export default Login;
